module.exports = __webpack_public_path__ + "static/media/visitor1.1a181a22.png";